var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget",class:_vm.widget_color?'':'widget-standard-color',style:(`
  ${_vm.height ? `height: ${_vm.height};` : `height: 100%;`}
  ${_vm.width ? `width: ${_vm.width};` : `width: 100%;`}
  ${_vm.widget_color ? `background-color: ${_vm.widget_color};` : ''}
  `)},[_c('div',{staticClass:"widget-content",style:(`
    ${_vm.title ? `height: calc(100% - 40px);` : `height: 100%;`}
    ${_vm.scrollable ? `overflow: auto;` : `overflow: hidden;`}
  `)},[_c('div',{style:(`
        ${_vm.content_split ? `width: 50%` : `width: 100%`}
        ${_vm.background_color ? `background-color: ${_vm.background_color}` : ''}
        ${_vm.scrollable ? `overflow: auto;` : `overflow: hidden;`}
        overflow: hidden;
        height: 100%;
    `)},[_vm._t("widgetContentOne")],2),(_vm.content_split)?_c('div',{style:(`
        width: 50%;
        ${_vm.background_color ? `background-color: ${_vm.background_color}` : ''}
        ${_vm.scrollable ? `overflow: auto;` : `overflow: hidden;`}
        overflow: hidden;
    `)},[_vm._t("widgetContentTwo")],2):_vm._e()]),_c('div',{staticClass:"widget-title"},[_c('div',{staticStyle:{"display":"flex","position":"relative","font-size":"24px"}},[_c('TText',{attrs:{"value":_vm.title,"size":"20","font_weight":"600"}}),(_vm.badgecount + 1)?_c('div',{staticClass:"widget-badge"},[_vm._v(" "+_vm._s(_vm.badgecount)+" ")]):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }